<template>
  <component
    :is="element"
    class="product-prices"
    :class="{ [$class('loading')]: loading }"
  >
    <span
      v-if="available === false"
      class="product-prices__sold-out"
      :class="classPrice"
      v-text="$string('product.prices.sold_out')"
    />
    <template v-else>
      <span
        v-if="varies"
        class="product-prices__varies"
        :class="classPrice"
        v-text="$string('product.prices.from')"
      />

      <span
        v-if="formattedCompareAtPrice && (!priceFirst || isFreeGift)"
        class="product-prices__compare-at-price"
        :class="classCompareAtPrice"
        v-text="formattedCompareAtPrice"
      />

      <span
        class="product-prices__price"
        :class="[
          classPrice,
          { 'product-prices__price--on-sale': formattedCompareAtPrice },
        ]"
        v-text="formattedPrice"
      />

      <span
        v-if="formattedCompareAtPrice && (priceFirst && !isFreeGift)"
        class="product-prices__compare-at-price"
        :class="classCompareAtPrice"
        v-text="formattedCompareAtPrice"
      />
    </template>
  </component>
</template>

<script>

/**
 * Vue: Product prices (product-prices)
 * -----------------------------------------------------------------------------
 * Global product prices template.
 *
 * @param {Boolean} [available] - If the product is available.
 * @param {String} [classCompareAtPrice] - Compare at price text classes.
 * @param {String} [classPrice] - Price text classes.
 * @param {Number|Boolean} compareAtPrice - Compare at price, in cents format.
 * @param {String} [element] - Custom element override.
 * @param {Boolean} [loading] - Loading state.
 * @param {Number} price - Product price, in cents format.
 * @param {Boolean} [priceFirst] - Display price before compare at price.
 * @param {Boolean} [varies] - Product variants vary in price.
 *
 */
export default {
  name: 'ProductPrices',

  props: {
    available: {
      type: Boolean,
      default: true,
    },
    classCompareAtPrice: {
      type: String,
      default: 'text-body-s-regular',
    },
    classPrice: {
      type: String,
      default: 'text-body-s-regular',
    },
    compareAtPrice: {
      type: [Boolean, Number],
      default: false,
      required: true,
    },
    element: {
      type: String,
      default: 'p',
    },
    isFreeGift: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    price: {
      type: [Boolean, Number],
      default: 0,
      required: true,
    },
    priceFirst: {
      type: Boolean,
      default: true,
    },
    varies: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      cnvsGlobal: true,
    }
  },

  computed: {

    /**
     * Compute compare at price template.
     * @returns {String}
     */
    formattedCompareAtPrice() {
      return this.compareAtPrice && this.price < this.compareAtPrice
        ? this.$formatMoney(this.compareAtPrice)
        : ''
    },

    /**
     * Compute price template.
     * @returns {String}
     */
    formattedPrice() {
      if (this.price === false) {
        return this.$string('accessibility.loading')
      }

      if (this.price <= 0) {
        return this.$string('product.prices.free')
      }

      return this.price ? this.$formatMoney(this.price) : ''
    },
  },
}
</script>
